//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ORDER_KEY } from './const'
import { RadioGroup, Radio } from 'vant'
export default {
    components: {
        RadioGroup,
        Radio
    },
    props: {
        item: Object,
        show_prev: Boolean
    },
    computed: {
        selected_text () {
            if (this.item.select) {
                return this.item.selected === -1 ? '请选择' : this.item.range[this.item.selected].text
            }
            return ''
        },
        answers () {
            if (!this.item.answers) {
                return []
            }
            return this.item.answers.map((item, i) => {
                return {
                    order: ORDER_KEY[i],
                    ...item
                }
            })
        },
        disabled () {
            if (this.item.select) {
                return this.item.selected === -1
            }
            if (this.item.answers) {
                return this.item.answers.every(({ checked }) => !checked)
            }
            return this.item.type != 'radio' && this.item.type != 'multi-radio' && this.item.type != 'inputs'
        }
    },
    methods: {
        next () {
            this.$emit('next')
        },
        prev () {
            this.$emit('prev')
        },
        change (i) {
            this.$emit('change', i)
        },
        changeInput (e) {
            console.log(e)
            const { dataset, value } = e.target
            const { qusstion, input } = dataset
            console.log(qusstion, input, value)
            this.$emit('changeInputs', qusstion, input, value)
        },
        changeSelect (e) {
            const { value } = e.target
            this.$emit('change', value)
        },
        changeRadio (e) {
            console.log('changeRadio', e)
            // const { value } = e.target
            // console.log(value)
            this.$emit('changeRadio', e)
        },
        changeMultiRadio (e) {
            const { value } = e.detail
            console.log(value, e)
            this.$emit('changeMultiRadio', value)
        },
        minus (i) {
            const item = this.answers[i]
            let val = item.input_val || 1
            val = val > 1 ? val - 1 : 1
            this.$emit('changeInput', i, val)
        },
        plus (i) {
            const item = this.answers[i]
            let val = item.input_val || 1
            val += 1
            this.$emit('changeInput', i, val)
        }
    }
}
